import React from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Modal,
} from "@mui/material";

export const RET_IR_OPTIONS = [
  { codigo: "303",  descripcion: "Honorarios profesionales y demás pagos por servicios relacionados con el título profesional", porcentaje: 10 },
  { codigo: "304",  descripcion: "Servicios donde predomina el intelecto no relacionados con el título profesional", porcentaje: 10 },
  { codigo: "304A", descripcion: "Comisiones y demás pagos por servicios predomina intelecto no relacionados con el título profesional", porcentaje: 10 },
  { codigo: "304B", descripcion: "Pagos a notarios y registradores de la propiedad y mercantil por sus actividades ejercidas como tales", porcentaje: 10 },
  { codigo: "304C", descripcion: "Pagos a deportistas, entrenadores, árbitros, miembros del cuerpo técnico por sus actividades ejercidas como tales", porcentaje: 10 },
  { codigo: "304D", descripcion: "Pagos a artistas por sus actividades ejercidas como tales", porcentaje: 10 },
  { codigo: "304E", descripcion: "Honorarios y demás pagos por servicios de docencia", porcentaje: 10 },

  { codigo: "307",  descripcion: "Servicios donde predomina la mano de obra", porcentaje: 2 },

  { codigo: "308",  descripcion: "Utilización o aprovechamiento de la imagen o renombre (personas naturales, sociedades, 'influencers')", porcentaje: 10 },
  { codigo: "309",  descripcion: "Servicios prestados por medios de comunicación y agencias de publicidad", porcentaje: 1 },

  { codigo: "311",  descripcion: "Por pagos a través de liquidación de compra (nivel cultural o rusticidad)", porcentaje: 2 },
  { codigo: "312",  descripcion: "Transferencia de bienes muebles de naturaleza corporal", porcentaje: 1.75 },
  { codigo: "312A", descripcion: "COMPRAS AL PRODUCTOR: de bienes de origen bioacuático, forestal y los descritos el art.27.1 de LRTI", porcentaje: 1 },
  { codigo: "312B", descripcion: "Impuesto a la Renta único para la actividad de producción y cultivo de palma aceitera", porcentaje: 1 },

  { codigo: "314A", descripcion: "Regalías por concepto de franquicias de acuerdo al Código INGENIOS (COESCCI) - pago a personas naturales", porcentaje: 10 },
  { codigo: "314B", descripcion: "Cánones, derechos de autor,  marcas, patentes y similares de acuerdo  al Código INGENIOS (COESCCI) – pago a personas naturales", porcentaje: 10 },
  { codigo: "314C", descripcion: "Regalías por concepto de franquicias de acuerdo al Código INGENIOS (COESCCI) - pago a sociedades", porcentaje: 10 },

  { codigo: "319",  descripcion: "Cuotas de arrendamiento mercantil (prestado por sociedades), inclusive la de opción de compra", porcentaje: 1 },
  { codigo: "320",  descripcion: "Arrendamiento de bienes inmuebles", porcentaje: 10 },

  { codigo: "322",  descripcion: "Seguros y reaseguros (primas y cesiones)", porcentaje: 1 },
  { codigo: "323",  descripcion: "Por rendimientos financieros pagados a naturales y sociedades  (No a IFIs)", porcentaje: 2 },
  { codigo: "323A", descripcion: "Por RF: depósitos Cta. Corriente", porcentaje: 2 },
  { codigo: "323B1",descripcion: "Por RF:  depósitos Cta. Ahorros Sociedades", porcentaje: 2 },
  { codigo: "323E", descripcion: "Por RF: depósito a plazo fijo  gravados", porcentaje: 2 },
  { codigo: "323F", descripcion: "Por rendimientos financieros: operaciones de reporto - repos", porcentaje: 2 },
  { codigo: "323G", descripcion: "Por RF: inversiones (captaciones) rendimientos distintos de aquellos pagados a IFIs", porcentaje: 2 },
  { codigo: "323H", descripcion: "Por RF: obligaciones", porcentaje: 2 },
  { codigo: "323I", descripcion: "Por RF: bonos convertible en acciones", porcentaje: 2 },
  { codigo: "323M", descripcion: "Por RF: Inversiones en títulos valores en renta fija gravados", porcentaje: 2 },
  { codigo: "323P", descripcion: "Por RF: Intereses pagados por entidades del sector público a favor de sujetos pasivos", porcentaje: 2 },
  { codigo: "323Q", descripcion: "Por RF: Otros intereses y rendimientos financieros gravados", porcentaje: 2 },

  { codigo: "324A", descripcion: "Por RF: Intereses en operaciones de crédito entre instituciones del sistema financiero y entidades economía popular y solidaria.", porcentaje: 1 },
  { codigo: "324B", descripcion: "Por RF: Por inversiones entre instituciones del sistema financiero y entidades economía popular y solidaria.", porcentaje: 1 },

  { codigo: "334",  descripcion: "Enajenación de derechos representativos de capital y otros derechos no cotizados en bolsa ecuatoriana", porcentaje: 1 },
  { codigo: "343A", descripcion: "Por energía eléctrica", porcentaje: 1 },
  { codigo: "343B", descripcion: "Actividades de construcción de obra material inmueble, urbanización, lotización o actividades similares", porcentaje: 1 },
  { codigo: "343C", descripcion: "Recepción de botellas plásticas no retornables de PET", porcentaje: 2 },
  { codigo: "344",  descripcion: "Otras retenciones aplicables el 2%", porcentaje: 2 },
  { codigo: "344A", descripcion: "Pago local tarjeta de crédito reportada por la Emisora de tarjeta de crédito, solo recap", porcentaje: 2 },
  { codigo: "344B", descripcion: "Adquisición de sustancias minerales dentro del territorio nacional", porcentaje: 2 },

  { codigo: "421",  descripcion: "Sin convenio de doble tributación por otros conceptos", porcentaje: 25 },

  { codigo: "3440", descripcion: "Otras retenciones aplicables el 2.75%", porcentaje: 2.75 },
  { codigo: "351",  descripcion: "Régimen Microempresas", porcentaje: 1.75 },
  { codigo: "303A", descripcion: "Servicios profesionales prestados por sociedades residentes", porcentaje: 3 },
  { codigo: "3482", descripcion: "Comisiones  a sociedades, nacionales o extranjeras residentes y establecimientos permanentes domiciliados en el país", porcentaje: 3 }
];


export const RET_IVA_OPTIONS = [
  { codigo: "1",  descripcion: "30% Bienes", porcentaje: 30 },
  { codigo: "2",  descripcion: "70% Servicios", porcentaje: 70 },

  { codigo: "3",  descripcion: "100% Honorarios, Arrendamientos Personas Naturales", porcentaje: 100 },
  { codigo: "3",  descripcion: "100% Exportadores", porcentaje: 100 },
  { codigo: "3",  descripcion: "100% Empresas Públicas", porcentaje: 100 },
  { codigo: "3",  descripcion: "100% Liquidación de Compra de Bienes y Servicios", porcentaje: 100 },
  { codigo: "3",  descripcion: "100% Contribuyentes Especiales", porcentaje: 100 },
  { codigo: "3",  descripcion: "100% Operadores de turismo", porcentaje: 100 },

  { codigo: "4",  descripcion: "IVA presuntivo por editores a margen de comercialización Voceadores", porcentaje: 12 },
  { codigo: "5",  descripcion: "Venta Periódicos y/o Revistas a distribuidores", porcentaje: 100 },
  { codigo: "6",  descripcion: "Venta Periódicos y/o Revistas a voceadores", porcentaje: 100 },

  { codigo: "7",  descripcion: "0% Retención en cero", porcentaje: 0 },
  { codigo: "8",  descripcion: "0% No procede retención", porcentaje: 0 },

  { codigo: "9",  descripcion: "10% Bienes (Contribuyentes Especiales)", porcentaje: 10 },
  { codigo: "10", descripcion: "20% Servicios (Contribuyentes Especiales)", porcentaje: 20 },
  { codigo: "11", descripcion: "50% Servicios (Exportadores de Recursos Naturales No Renovables)", porcentaje: 50 }
];


export const RET_IR_LIST = RET_IR_OPTIONS;
export const RET_IVA_LIST = RET_IVA_OPTIONS;

export const RetentionModal = ({ open, onClose, title, items, onPick }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "#fff",
          borderRadius: 2,
          width: 900,
          maxWidth: "95vw",
          boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 2,
            borderBottom: "1px solid #e6e6e6",
          }}
        >
          <Typography sx={{ fontSize: 22, fontWeight: 700, color: "#1f2a37" }}>
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <Typography sx={{ fontSize: 24, fontWeight: 700, color: "#1976d2" }}>
              ×
            </Typography>
          </IconButton>
        </Box>

        <Box sx={{ px: 3, py: 2 }}>
          <Box
            sx={{
              border: "1px solid #e6e6e6",
              borderRadius: 1.5,
              overflow: "hidden",
            }}
          >
            <Box sx={{ maxHeight: 420, overflow: "auto" }}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ bgcolor: "#f3f4f6" }}>
                    <TableCell sx={{ width: 100, fontWeight: 700 }}>
                      Código
                    </TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>
                      Descripción
                    </TableCell>
                    <TableCell
                      sx={{ width: 100, fontWeight: 700 }}
                      align="right"
                    >
                      %
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {items.map((it, idx) => (
                    <TableRow
                      key={`${it.codigo}-${idx}`}
                      hover
                      sx={{ cursor: "pointer" }}
                      onClick={() => onPick(it)}
                    >
                      <TableCell
                        sx={{ color: "#1976d2", fontWeight: 700 }}
                      >
                        {it.codigo}
                      </TableCell>
                      <TableCell>
                        {it.descripcion}
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: 700 }}
                        align="right"
                      >
                        {it.porcentaje}%
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default RetentionModal;
